// Exports
module.exports = {
	"gridColumnSize": "100px",
	"gridGap": "10px",
	"gridPadding": "10px"
};
